<template>
    <div>
        <ubi-panel>
            <ubi-form-group :title="$t('posts.houseTitle')">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="$labels.nb_pieces_logement"
                                      prop="nb_pieces_logement"
                        >
                            <el-input  v-mask="'#################'" v-model.number="post.nb_pieces_logement" type="nb_pieces_logement">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$labels.nombre_de_chambres"
                                      prop="nombre_de_chambres"
                        >
                            <el-input  v-mask="'#################'" v-model.number="post.nombre_de_chambres" type="nombre_de_chambres">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$labels.nombre_niveaux"
                                      prop="nombre_niveaux"
                        >
                            <el-input  v-mask="'#################'" v-model.number="post.nombre_niveaux" type="nombre_niveaux">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item :label="$labels.surface_sejour"
                                      prop="surface_sejour"
                        >
                            <el-input  v-mask="'#################'" v-model.number="post.surface_sejour" type="surface_sejour">
                                <template slot="append">m²</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{$labels.mitoyennete}} <el-button class="el-icon-error reset-radio"
                                                                                             v-if="post.mitoyennete != '' && post.mitoyennete != undefined && post.mitoyennete != null"
                                                                                             @click="post.mitoyennete = null"
                                                                                             circle></el-button></div>
                            <el-radio-group v-model="post.mitoyennete">
                                <el-radio
                                        v-for="mitoyenneteChoice in this.$parent.getChoices('mitoyennete')"
                                        :label="mitoyenneteChoice"
                                        :value="mitoyenneteChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.chauffage_energie">
                            <el-select
                                    v-model="post.chauffage_energie"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="energieChauffageChoice in this.$parent.getChoices('chauffage_energie')"
                                        :key="energieChauffageChoice"
                                        :label="energieChauffageChoice"
                                        :value="energieChauffageChoice"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{ $labels.eau_chaude_distribution }}
                                <el-button class="el-icon-error reset-radio"
                                           v-if="post.eau_chaude_distribution != '' && post.eau_chaude_distribution != undefined && post.eau_chaude_distribution != null"
                                           @click="post.eau_chaude_distribution = null"
                                           circle></el-button>
                            </div>
                            <el-radio-group v-model="post.eau_chaude_distribution">
                                <el-radio
                                        v-for="eauChaudeDistributionChoice in this.$parent.getChoices('eau_chaude_distribution')"
                                        :label="eauChaudeDistributionChoice"
                                        :value="eauChaudeDistributionChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item :label="$labels.garage">
                            <el-radio v-model="post.garage" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.garage" label="non">{{ $t("general.no") }}</el-radio>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="post.garage == 'oui'">
                        <el-form-item>
                            <div style="font-size: 12px;">{{ $labels.garage_emplacement }} <el-button class="el-icon-error reset-radio"
                                                                                                      v-if="post.garage_emplacement != '' && post.garage_emplacement != undefined && post.garage_emplacement != null"
                                                                                                      @click="post.garage_emplacement = null"
                                                                                                      circle></el-button></div>
                            <el-radio-group v-model="post.garage_emplacement">
                                <el-radio
                                        v-for="typeGarageChoice in this.$parent.getChoices('garage_emplacement')"
                                        :label="typeGarageChoice"
                                        :value="typeGarageChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item :label="$labels.facade_construction_max"
                                      prop="facade_construction_max"
                        >
                            <el-input  v-mask="'#################'" v-model.number="post.facade_construction_max" type="facade_construction_max">
                                <template slot="append">M</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$labels.hauteur_maximum"
                                      prop="hauteur_maximum"
                        >
                            <el-input  v-mask="'#################'" v-model.number="post.hauteur_maximum" type="hauteur_maximum">
                                <template slot="append">M</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.style_construction">
                            <el-select
                                    v-model="post.style_construction"
                                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                                    clearable
                                    filterable
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="styleConstructionChoice in this.$parent.getChoices('style_construction')"
                                        :key="styleConstructionChoice"
                                        :label="styleConstructionChoice"
                                        :value="styleConstructionChoice"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="23">
                        <el-form-item>
                            <div style="font-size: 12px;">{{$labels.type_construction}} <el-button class="el-icon-error reset-radio"
                                                                                                   v-if="post.type_construction != '' && post.type_construction != undefined && post.type_construction != null"
                                                                                                   @click="post.type_construction = null"
                                                                                                   circle></el-button></div>
                            <el-radio-group v-model="post.type_construction">
                                <el-radio
                                        v-for="typeConstructionChoice in this.$parent.getChoices('type_construction')"
                                        :label="typeConstructionChoice"
                                        :value="typeConstructionChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item>
                            <div style="font-size: 12px;">{{$labels.type_livraison}} <el-button class="el-icon-error reset-radio"
                                                                                                v-if="post.type_livraison != '' && post.type_livraison != undefined && post.type_livraison != null"
                                                                                                @click="post.type_livraison = null"
                                                                                                circle></el-button></div>
                            <el-radio-group v-model="post.type_livraison">
                                <el-radio
                                        v-for="typeLivraisonChoice in this.$parent.getChoices('type_livraison')"
                                        :label="typeLivraisonChoice"
                                        :value="typeLivraisonChoice">
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.propertyPartnerTitle')">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.propertyPartnerCompany')">
                            <el-input v-model="post.partenaire_foncier_societe">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item :label="$t('posts.edit.propertyPartnerLastname')">
                            <el-input v-model="post.partenaire_foncier_nom">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('posts.edit.propertyPartnerFirstname')">
                            <el-input v-model="post.partenaire_foncier_prenom">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item :label="$t('posts.edit.propertyPartnerPhone')">
                            <el-input v-model="post.partenaire_foncier_telephone">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <ubi-panel>
            <ubi-form-group :title="$t('posts.labelsAndCertificationsTitle')">
                <el-row :gutter="20">
                    <el-col :span="12"><el-checkbox v-model="post.label_nf_maison_individuelle" true-label="oui" false-label="non">{{$labels.label_nf_maison_individuelle}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_hqe" true-label="oui" false-label="non">{{$labels.label_hqe}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.re_2020" true-label="oui" false-label="non">{{$labels.re_2020}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.re_2025" true-label="oui" false-label="non">{{$labels.re_2025}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_thpe" true-label="oui" false-label="non">{{$labels.label_thpe}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_he" true-label="oui" false-label="non">{{$labels.label_he}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_he_effinergie" true-label="oui" false-label="non">{{$labels.label_he_effinergie}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_qualibat" true-label="oui" false-label="non">{{$labels.label_qualibat}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_acermi" true-label="oui" false-label="non">{{$labels.label_acermi}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_ce" true-label="oui" false-label="non">{{$labels.label_ce}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_promotelec" true-label="oui" false-label="non">{{$labels.label_promotelec}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_maison_de_qualite" true-label="oui" false-label="non">{{$labels.label_maison_de_qualite}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_maison_de_confiance" true-label="oui" false-label="non">{{$labels.label_maison_de_confiance}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_biodivercity" true-label="oui" false-label="non">{{$labels.label_biodivercity}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_biosource_niveau_1" true-label="oui" false-label="non">{{$labels.label_biosource_niveau_1}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.label_biosource_niveau_2" true-label="oui" false-label="non">{{$labels.label_biosource_niveau_2}}</el-checkbox></el-col>
                    <el-col :span="12"><el-checkbox v-model="post.re_seuil_2028" true-label="oui" false-label="non">{{$labels.re_seuil_2028}}</el-checkbox></el-col>
                </el-row>
            </ubi-form-group>
        </ubi-panel>

        <dpe-ges :post="post"></dpe-ges>
        <isolation-thermique-solaire :post="post"></isolation-thermique-solaire>

    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import ElButton from '../../../../components/Button'
import DpeGes from '../Block/DpeGes'
import IsolationThermiqueSolaire from '../Block/IsolationThermiqueSolaire'
import UbiPanel from '@/components/Panel.vue'
import UbiFormGroup from '@/components/forms/FormGroup.vue'

export default {
  name: 'PostEditImmoObject1200CmiModel',
  components: { UbiFormGroup, UbiPanel, ElButton, DpeGes, IsolationThermiqueSolaire },
  props: ['post', 'ddList'],
  data () {
    return {}
  },
  computed: {},
  methods: {},
  async beforeMount () {
    let codes = ['mitoyennete', 'exposition', 'chauffage_energie', 'style_construction', 'type_construction', 'type_livraison', 'garage_emplacement', 'exposition', 'environnement', 'mandat_statut', 'modalites_recuperation_charges_locatives', 'eau_chaude_distribution']

    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type === 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      this.loading = false
      return false
    }
    this.$emit('ddList-update', definitionDonneeListeeByCode)

    for (let i = this.$parent.getChoices('mitoyennete').length - 1; i >= 0; i--) {
      if (this.$parent.getChoices('mitoyennete')[i] === 'oui') {
        this.$parent.getChoices('mitoyennete').splice(i, 1)
      }
    }
  }
}
</script>

<style>
    .reset-radio {
        font-size: 20px;
        color: lightgrey;
        border: none;
    }
</style>
